// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cofagrigus: PokeData = {
  "id": 563,
  "name": "cofagrigus",
  "height": 17,
  "weight": 765,
  "base_experience": 169,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "disable",
    "night-shade",
    "haze",
    "curse",
    "protect",
    "scary-face",
    "destiny-bond",
    "mean-look",
    "shadow-ball",
    "will-o-wisp",
    "grudge",
    "astonish",
    "dark-pulse",
    "shadow-claw",
    "ominous-wind",
    "guard-split",
    "power-split",
    "hex",
    "crafty-shield"
  ],
  "moves": [
    "night-shade",
    "curse",
    "protect",
    "scary-face",
    "shadow-ball",
    "dark-pulse",
    "lick",
    "spectral-snatch",
    "shadow-dagger",
    "poltergeist",
    "soul-sacrifice",
    "shadow-sneak",
    "shadow-claws"
  ],
  "evolution_chain": {
    "id": 287,
    "item": null,
    "species": [
      {
        "name": "yamask",
        "order": 563,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cofagrigus",
        "order": 564,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "runerigus",
        "order": 867,
        "types": [
          PokeType.GROUND,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TAKE_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 169,
    "speed": 55,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
